exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".speechControlsContainer .speechToText{margin-left:10px}.speechControlsContainer .speechToText,.speechControlsContainer .textToSpeech{border-radius:50%;width:auto;height:25px;cursor:pointer}.speechControlsContainer .chromeTip{display:inline-block;margin-left:10px;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/questions/speech_controls.scss
// module id = 1526
// module chunks = 0